(function () {
  function initAutoplay(slider) {
    var interval = Number(slider.dataset.autoplayInterval || 4500);
    var timer = null;
    var paused = false;
    var resumeTimeout = null;

    function scrollToNext() {
      if (paused) return;
      var slide = slider.querySelector('.slider__slide');
      if (!slide) return;

      var styles = window.getComputedStyle(slide);
      var slideWidth = slide.getBoundingClientRect().width + parseFloat(styles.marginRight || 0);
      var maxScroll = slider.scrollWidth - slider.clientWidth;

      if (slider.scrollLeft >= maxScroll - 4) {
        slider.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        slider.scrollBy({ left: slideWidth, behavior: 'smooth' });
      }
    }

    function start() {
      stop();
      timer = setInterval(scrollToNext, interval);
    }

    function stop() {
      if (timer) clearInterval(timer);
    }

    function pause() {
      paused = true;
      if (resumeTimeout) clearTimeout(resumeTimeout);
    }

    function resumeAfterDelay(delay) {
      if (resumeTimeout) clearTimeout(resumeTimeout);
      resumeTimeout = setTimeout(function () {
        paused = false;
      }, delay);
    }

    slider.addEventListener('mouseenter', pause);
    slider.addEventListener('mouseleave', function () {
      resumeAfterDelay(0);
    });
    slider.addEventListener(
      'touchstart',
      function () {
        pause();
      },
      { passive: true }
    );
    slider.addEventListener(
      'touchend',
      function () {
        resumeAfterDelay(6000);
      },
      { passive: true }
    );
    slider.addEventListener('focusin', pause);
    slider.addEventListener('focusout', function () {
      resumeAfterDelay(0);
    });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    start();
  }

  document.querySelectorAll('[data-testimonial-autoplay]').forEach(initAutoplay);
})();
